import { Inbox } from '@crehana/compass.icons.outline/v2/inbox';
import { Plus } from '@crehana/compass.icons.outline/v2/plus';
import { Button } from '@crehana/compass.ui/v3/button';

import { useTranslation } from '../../../i18n';

type TRequestsEmptyProps = {
  onCreateClick: () => void;
};

export const RequestsEmpty = ({ onCreateClick }: TRequestsEmptyProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-cds-gap-4 tw-cds-p-7 tw-text-center">
      <div className="tw-cds-bg-layer-01 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-cds-p-5">
        <Inbox size={32} className="tw-cds-text-subtle" />
      </div>
      <div className="tw-flex tw-flex-col tw-cds-gap-2">
        <h3 className="tw-cds-font-subtitle-03 tw-cds-text-primary">
          {t('EMPTY_STATE_TITLE')}
        </h3>
        <p className="tw-cds-font-body-02 tw-cds-text-secondary tw-max-w-[44rem]">
          {t('EMPTY_STATE_DESCRIPTION')}
        </p>
      </div>
      <Button
        type="button"
        variant="primary"
        startIcon={Plus}
        onClick={onCreateClick}
      >
        {t('BUTTON_CREATE_REQUEST')}
      </Button>
    </div>
  );
};
